import React from 'react';

function AssetWriteOffReport() {
  return <div>AssetWriteOffReport</div>;
}

export default AssetWriteOffReport;
